import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, LOCALE_ID, makeEnvironmentProviders, PLATFORM_ID, REQUEST } from '@angular/core';

import { availableLanguages } from './models/available-languages.const';

const localeIdFactory = (document = inject(DOCUMENT), platformId = inject(PLATFORM_ID), request = inject(REQUEST)) => {
  const browserLocaleIds = request?.headers.get('Accept-Language') || document.defaultView?.navigator.language;
  let localeId = browserLocaleIds?.split(',')[0].split('-')[0] ?? 'en';

  if (isPlatformBrowser(platformId)) {
    localeId = localStorage.getItem('language') ?? localeId;
  }

  return availableLanguages.includes(localeId) ? localeId : 'en';
};

export const provideLocaleId = () => makeEnvironmentProviders([{ provide: LOCALE_ID, useFactory: localeIdFactory }]);
